import { useCallback } from "react";

import { useStore } from "../../redux/hooks.js";
import { DataBrowserState } from "../../redux/slices/dataBrowserSlice.js";
import { useStableRef } from "../useStableRef.js";

type UseDataBrowserGetterArgs<A extends unknown[], T> = {
  selector: (state: DataBrowserState, ...args: A) => T;
};

type UseDataBrowserGetterResult<A extends unknown[], T> = (...args: A) => T;

export function useDataBrowserGetter<
  A extends unknown[],
  T = DataBrowserState,
>({
  selector,
}: UseDataBrowserGetterArgs<A, T>): UseDataBrowserGetterResult<A, T> {
  const selectorRef = useStableRef(selector);

  const store = useStore();
  return useCallback(
    (...args: A) => {
      return selectorRef.current(store.getState().dataBrowser, ...args);
    },
    [selectorRef, store],
  );
}
